import { httpsCallable } from 'firebase/functions';
import { functions } from '../../config/firebase';

export async function setAdminRole({ targetUid, role, operationId }) {
  const fn = httpsCallable(functions, 'setAdminRole');
  const { data } = await fn({
    targetUid,
    role: role === '' ? null : role,
    operationId,
  });
  return data;
}

export async function getAdminSecurityConfig() {
  const fn = httpsCallable(functions, 'getAdminSecurityConfig');
  const { data } = await fn({});
  return data;
}
